/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockPlay = createReactComponent("clock-play", "IconClockPlay", [
  ["path", { d: "M12 7v5l2 2", key: "svg-0" }],
  ["path", { d: "M17 22l5 -3l-5 -3z", key: "svg-1" }],
  ["path", { d: "M13.017 20.943a9 9 0 1 1 7.831 -7.292", key: "svg-2" }]
]);

export { IconClockPlay as default };
//# sourceMappingURL=IconClockPlay.js.map
